import { Accordion, Flex } from '@mantine/core';

import { TextInput } from '@components';

export const SendReportSettings = ({ form, handleChange, editDisabled }) => {
  return (
    <Accordion.Item key="sendReport" value="sendReport">
      <Accordion.Control>Send report</Accordion.Control>
      <Accordion.Panel>
        <Flex m="md" gap="md" wrap="wrap">
          <TextInput
            value={form.values.highValueSettings.sendReport.referenceValue}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.referenceValue');
            }}
            label="Reference value"
            w={160}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.webValueChecked}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.webValueChecked');
            }}
            label="Web value checked"
            w={180}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedUnitPrice}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedUnitPrice');
            }}
            label="Suggested unit price"
            w={190}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedValue}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedValue');
            }}
            label="Suggested value"
            w={160}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.resonableValueRate}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.resonableValueRate');
            }}
            label="Reasonable value rate"
            w={190}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.netMargin}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.netMargin');
            }}
            label="Net margin"
            w={130}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedTaxRate}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedTaxRate');
            }}
            label="Suggested tax rate"
            w={180}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.dutyEuro}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.dutyEuro');
            }}
            label="Duty euro"
            w={110}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedDutyEuro}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedDutyEuro');
            }}
            label="Suggested duty euro"
            w={190}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.calculatedImpact}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.calculatedImpact');
            }}
            label="Calculated impact"
            w={170}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedHsCode}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedHsCode');
            }}
            label="Suggested HS code"
            w={190}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.suggestedDescription}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.suggestedDescription');
            }}
            label="Suggested description"
            w={200}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.LRN}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.LRN');
            }}
            label="LRN"
            w={100}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.goodsItem}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.goodsItem');
            }}
            label="Goods item"
            w={120}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.annotationNote}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.annotationNote');
            }}
            label="Annotation note"
            w={160}
            disabled={editDisabled}
          />
        </Flex>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
